selectionSetMatchesResult